import { useEffect, useMemo, useRef } from 'react'
import { extractLayoutSnapLines } from '@/lib/guides/smart-guides'
import type { ShapeManagerStateApi } from './use-shape-manager-state'

/** Ref mirrors of the smart-guide and snap settings, plus the layout snap lines derived from guides. */
export function useSnapRefs(ctx: ShapeManagerStateApi) {
  const {
    gridSnapStep,
    guides,
    onActiveSmartGuidesChange,
    resolvedGridSnapLiveRects,
    smartGuidesEnabled,
    snapToGrid,
    snapToGuides,
  } = ctx

  const onActiveSmartGuidesChangeRef = useRef(onActiveSmartGuidesChange)

  useEffect(() => {
    onActiveSmartGuidesChangeRef.current = onActiveSmartGuidesChange
  }, [onActiveSmartGuidesChange])

  const smartGuidesEnabledRef = useRef(smartGuidesEnabled)

  useEffect(() => {
    smartGuidesEnabledRef.current = smartGuidesEnabled
  }, [smartGuidesEnabled])

  const snapToGridRef = useRef(snapToGrid)

  useEffect(() => {
    snapToGridRef.current = snapToGrid
  }, [snapToGrid])

  const gridSnapStepRef = useRef(gridSnapStep)

  gridSnapStepRef.current = gridSnapStep
  const gridSnapLiveRectsRef = useRef(resolvedGridSnapLiveRects)

  gridSnapLiveRectsRef.current = resolvedGridSnapLiveRects

  const snapToGuidesRef = useRef(snapToGuides)

  useEffect(() => {
    snapToGuidesRef.current = snapToGuides
  }, [snapToGuides])

  const layoutSnapLines = useMemo(() => extractLayoutSnapLines(guides), [guides])

  return {
    onActiveSmartGuidesChangeRef,
    smartGuidesEnabledRef,
    snapToGridRef,
    gridSnapStepRef,
    gridSnapLiveRectsRef,
    snapToGuidesRef,
    layoutSnapLines,
  }
}

export type SnapRefsApi = ReturnType<typeof useSnapRefs>
